export default __webpack_public_path__ + "static/media/select-arrow.48eec090.svg";